import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '../../styles';
import { Column } from '../layout';
import { Counter } from './counter';
import { Editor } from './editor';
import { PlaceholderText } from './placeholder_text';
export function PostCallEditor(props) {
    return (_jsxs(Wrapper, { "data-testid": "post-call-notes-editor", children: [_jsx(PlaceholderText, { left: "1.5rem" }), _jsx(EditorWrapper, { children: _jsx(Editor, { ...props }) }), _jsx(Counter, {})] }));
}
const EditorWrapper = styled.div({
    minHeight: '7.75rem',
    maxHeight: '32.75rem',
    overflowY: 'auto',
    marginBottom: '1rem',
});
const Wrapper = styled(Column)(({ theme }) => ({
    background: theme.colors.white,
    padding: '.75rem 1rem',
    borderBottomLeftRadius: '.5rem',
    borderBottomRightRadius: '.5rem',
    position: 'relative',
    justifyContent: 'space-between',
    overflowWrap: 'break-word',
}));
//# sourceMappingURL=post_call_editor.js.map